const baseClassName = 'clbb-solution-picker';

export { baseClassName };
//# sourceMappingURL=index.js.map
